export default __webpack_public_path__ + "static/media/nucampreact.e0faabe6.PNG";